import Dataman from 'App/Dataman';

export function searchNewsletterDomains(term, id = null) {
  const filter = { name: term, itemsPerPage: 200, page: 1 };
  if (id && Number(id)) {
    filter.id = id;
  }
  return Dataman.DB.newsletter.getNewsletterDomains(filter).then((res) => {
    return res.data?.items?.map((el) => ({ text: el.name, value: el.id }));
  });
}
